
import BaseModel from "../base_model.js";

class RawCompanyPersonModel extends BaseModel {

  rawFormFields(item = undefined) {
    return [
      {
        name: "firstName",
        displayName: this.fieldDisplayName("firstName"),
        type: "text",
        weight: 6
      },
      {
        name: "lastName",
        displayName: this.fieldDisplayName("lastName"),
        type: "text",
        weight: 6,
        required: true
      },
    ]
  }

  i18nScope() {
    return "model.companies.person";
  }

}
const CompanyPersonModel = new RawCompanyPersonModel();

export { RawCompanyPersonModel, CompanyPersonModel }
